export default __webpack_public_path__ + "static/services_header-000a6e596046d7bde1c31b99d6c330a7.jpg";